import { DEEPLINK_PATH } from './deeplinkConstants';

export default function isDeepLink() {
    let path = location ? location.pathname : '';
    const segments = path.split('/');

    return segments.indexOf(DEEPLINK_PATH) >= 0;
}
